import axios from '../../../services/axios';
import { axiosNTL } from '../../../services/axios';

import { UserData } from '../types/ContentData';
import { UserGroupsBody } from '../types/UserGroupsBody';
import CourseSyllabusData from '../types/CourseSyllabusData';

const fetchUsersList = () => axiosNTL
	.get('/user/fetchUsers')
	.then((res: any) => {
		const users: UserData[] = res.responseObject;
		return Promise.resolve(users);
	});


const group = () => {
	return axiosNTL.get('/userGroups/')
		.then((res: any) => {
			let userGroups: UserGroupsBody[] = res.responseObject;
			return Promise.resolve(userGroups);
		});
}


const userService = {
	fetchUsersList,
	group
};

export default userService;